import React from 'react'
import Select, {OnChangeValue} from 'react-select'
import {Nullable} from '../../../app/TypeHelpers'
import {ErrorHandlingFormProps} from './hoc/createErrorHandlingForm'
import {withErrorSubscribe} from './hoc/withErrorSubscribe'
import {isMobile} from 'react-device-detect'
import PPSelect from './PPSelect'
import {SelectChangeEvent} from '@mui/material/Select'

interface Props {
    options: ComboBoxOption[]
    defaultValue: Nullable<string>
    onChangeSelected: (selectedValue: string, selectedLabel?: string) => void
}

interface States {
    selectedValue: ComboBoxOption
    options: ComboBoxOption[]
    defaultLabel: string
    selectedLabel: string
}

export interface ComboBoxOption {
    label: string
    value: string
}

class PPComboBox
    extends React.Component<Props & ErrorHandlingFormProps, States> {

    constructor(props: Readonly<Props & ErrorHandlingFormProps>) {
        super(props)

        const options = this.props.options.length !== 0 && this.props.options[0].value === ''
            ? this.props.options
            : [
                {label: '', value: ''},
                ...this.props.options,
            ]
        const defaultOption = this.getDefaultOption(options, this.props.defaultValue)

        this.state = {
            selectedValue: defaultOption,
            options: options,
            defaultLabel: defaultOption.label,
            selectedLabel: defaultOption.label,
        }

        this.onChangeSelectComponent = this.onChangeSelectComponent.bind(this)
    }

    onChangeSelectComponent(value: OnChangeValue<ComboBoxOption, false>): void {
        if (value === null) {
            return
        }

        this.setState({
            selectedValue: value,
            selectedLabel: value.label.trim(),
        })
        const selectedValue = value.value
        const selectedLabel = value.label
        this.props.onChangeSelected(selectedValue, selectedLabel)
    }

    onChangeSelectComponentM = (event: SelectChangeEvent<unknown>): void => {
        const value = event.target.value as string
        const option = this.state.options
            .find(opt => opt.value === value)
        if (!option) {
            return
        }

        this.setState({
            selectedValue: option,
            selectedLabel: option.label.trim(),
        })
        const selectedValue = option.value
        const selectedLabel = option.label
        this.props.onChangeSelected(selectedValue, selectedLabel)
    }

    getDefaultOption(options: ComboBoxOption[], defaultValue: Nullable<string>): ComboBoxOption {
        if (defaultValue) {
            for (const option of options) {
                if (option.value === defaultValue) {
                    return option
                }
            }
        }
        return options[0]
    }

    render(): React.ReactElement {
        if (isMobile) {
            return <PPSelect
                eventEmitter={this.props.eventEmitter}
                eventKeys={this.props.eventKeys}
                data={this.state.options
                    .map(option => ({label: option.label, value: `${option.value}`}))}
                onChange={this.onChangeSelectComponentM}
                value={this.state.selectedValue.value}
            />
        } else {
            return <Select
                inputId={'selectedComponent'}
                value={this.state.selectedValue}
                options={this.state.options}
                onChange={this.onChangeSelectComponent}
                menuPortalTarget={document.body}
                styles={{
                    menuPortal: base => ({...base, zIndex: 9999}),
                    container: base => ({...base, width: '100%'}),
                    option: base => ({...base, minHeight: '36px'}),
                }}
            />
        }
    }
}

export default withErrorSubscribe(PPComboBox)
